import React, { useRef } from 'react';
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip } from 'chart.js';
import { FaPlus, FaHome, FaFilePdf } from "react-icons/fa";
import { Card, Container, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { parseISO, format } from 'date-fns';
import { ptBR } from 'date-fns/locale'; // Importando o locale para português
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import dataFormatada from '../../hooks/Date/dataFormatada';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

// Register pdfMake fonts
pdfMake.vfs = pdfFonts.vfs;

const RelatorioHistograma = ({ filtro, dataHora, dados, setShowForm, setShowRelatorio }) => {
    const navigate = useNavigate();
    const chartRef = useRef(null);

    const handleGoHome = () => {
        navigate("/home");
    };

    const handleForm = () => {
        setShowForm(true);
        setShowRelatorio(false);
    };

    const gerarPDF = async () => {
        const chart = chartRef.current;
        const chartBase64 = chart.toBase64Image();

        const tableBody = [
            [
                { text: 'Período', style: 'tableHeader' },
                { text: 'Manutenções', style: 'tableHeader' },
            ]
        ];

        dados.data.histograma.forEach(histograma => {
            tableBody.push([
                { text: `${dataFormatada(histograma.inicio)}-${dataFormatada(histograma.fim)}`, style: 'tableData' },
                { text: histograma.manutencoesCorretivas, style: 'tableData' }
            ]);
        });

        const chartDataTable = [
            [
                { text: 'Período', style: 'tableHeader' },
                { text: 'Manutenções', style: 'tableHeader' },
            ]
        ];

        dados.data.histograma.forEach((histograma, index) => {
            chartDataTable.push([
                { text: `${dataFormatada(histograma.inicio)}-${dataFormatada(histograma.fim)}`, style: 'tableData' },
                { text: histograma.manutencoesCorretivas, style: 'tableData' }
            ]);
        });

        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [40, 60, 40, 60],
            content: [
                { text: 'Histograma de Manutenções Corretivas', style: 'header' },
                {
                    text: `Empresa: ${filtro.nomeEmpresa}\nUnidade: ${filtro.nomeUnidade || "Todas as Unidades"}\nTipo de Aplicação: ${filtro.descricaoTipoAplicacao || "Todos os Tipos de Aplicação"}\nAplicação: ${filtro.descricaoAplicacao || "Todas as aplicações"}\nManutentor: ${filtro.nomeManutentor || "Todos os Manutentores"}\nSolicitante: ${filtro.nomeSolicitante || "Todos os Solicitantes"}\nGerado Em: ${dataHora}`,
                    style: 'subheader',
                    margin: [0, 10, 0, 20]
                },
                {
                    image: chartBase64,
                    width: 500,
                    alignment: 'center',
                    margin: [0, 20, 0, 0]
                },
                {
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: tableBody
                    },
                    layout: 'lightHorizontalLines', // Estilo de tabela mais elegante
                    margin: [0, 0, 0, 20]
                },
            ],
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 14,
                    margin: [0, 10, 0, 10]
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                    fillColor: '#CCCCCC'
                },
                tableData: {
                    margin: [0, 5, 0, 5],
                    fontSize: 11
                }
            }
        };

        pdfMake.createPdf(docDefinition).download('RelatorioHistogramaManutencoesCorretivas.pdf');
    };

    const labels = dados.data.histograma.map((item) => {
        const inicio = parseISO(item.inicio);
        return format(inicio, 'MMMM', { locale: ptBR }); // Formata a data para mostrar mês e ano em português
    });

    const dataValues = dados.data.histograma.map((item) => item.manutencoesCorretivas);

    const histogramaChart = {
        labels: labels,
        datasets: [
            {
                backgroundColor: 'rgba(255,99,71,0.6)',
                borderColor: 'rgba(255,0,0,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,0,0,0.7)',
                hoverBorderColor: 'rgba(178,34,34,1)',
                data: dataValues,
                barPercentage: 1.0,
                categoryPercentage: 1.0,
                maxBarThickness: 80,
            },
        ],
    };

    const histogramaOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Remover a legenda
            },
            title: {
                display: false,
                text: 'Histograma de Manutenções Corretivas',
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                grid: {
                    display: false, // Remove as linhas de grade no eixo x
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: true, // Mostra as linhas de grade no eixo y
                },
            },
        },
    };

    return (
        <Container align="left" className="d-flex">
            <button
                onClick={gerarPDF}
                style={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                    zIndex: 9999,
                    backgroundColor: "#FF0000",
                    padding: 20,
                    borderRadius: 40,
                    border: "none",
                    cursor: "pointer",
                }}
            >
                <FaFilePdf size={25} color="white" /> {/* Ícone de PDF */}
            </button>
            <button
                onClick={handleForm}
                style={{
                    position: "fixed",
                    bottom: 20,
                    right: 90,
                    zIndex: 9999,
                    backgroundColor: "#41B06E",
                    padding: 20,
                    borderRadius: 40,
                    border: "none",
                    cursor: "pointer",
                }}
            >
                <FaPlus size={25} color="white" />
            </button>
            <button
                onClick={handleGoHome}
                style={{
                    position: "fixed",
                    bottom: 20,
                    right: 160,
                    zIndex: 9999,
                    backgroundColor: "#B4B4B8",
                    padding: 20,
                    borderRadius: 40,
                    border: "none",
                    cursor: "pointer",
                }}
            >
                <FaHome size={25} color="white" />
            </button>
            <div className="border border-dark p-3">
                <div className="text-center">
                    <h3><strong>Histograma de Manutenções Corretivas</strong></h3>
                </div>
                <div>
                    <ul className="list-unstyled">
                        <li><strong>Empresa:</strong> {filtro.nomeEmpresa}</li>
                        <li><strong>Unidade:</strong> {filtro.nomeUnidade || 'Todas as Unidades'}</li>
                        <li><strong>Tipo de Aplicação:</strong> {filtro.descricaoTipoAplicacao || 'Todos os Tipos de Aplicação'}</li>
                        <li><strong>Aplicação:</strong> {filtro.descricaoAplicacao || 'Todas as Aplicações'}</li>
                        <li><strong>Manutentor:</strong> {filtro.nomeManutentor || 'Todos os Manutentores'}</li>
                        <li><strong>Solicitante:</strong> {filtro.nomeSolicitante || 'Todos os Solicitantes'}</li>
                        <li><strong>Período:</strong> {`${filtro.dataInicial}-${filtro.dataFinal}`}</li>
                        <li><strong>Gerado Em:</strong> {dataHora}</li>
                    </ul>
                </div>
                <div style={{ width: '600px', height: '400px', marginTop: '20px', marginBottom:'40px' }}>
                    <Bar ref={chartRef} data={histogramaChart} options={histogramaOptions} />
                </div>
                <Card>
                    <div className="table-responsive">
                        <Table striped hover>
                            <thead className="thead-light">
                                <tr>
                                    <th>Período</th>
                                    <th>Manutenções</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dados.data.histograma.map((histograma, idx) => (
                                    <tr key={idx}>
                                        <td>{`${dataFormatada(histograma.inicio)} - ${dataFormatada(histograma.fim)}`}</td>
                                        <td>{histograma.manutencoesCorretivas || '0'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card>
            </div>
        </Container>
    );
};

export default RelatorioHistograma;
